import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ClickOutsideDirective} from "../../directives/click.outside";

declare const _: any;

@Component({
  selector: 'app-tpiq-input-search',
  standalone: true,
  imports: [CommonModule, FormsModule, ClickOutsideDirective],
  templateUrl: './tpiq-input-search.component.html',
  styleUrl: './tpiq-input-search.component.scss'
})
export class TpiqInputSearchComponent {
  allData: Array<any> = [];
  searchEntries: Array<any> = [];
  placeHolder: string;
  searchKey: string;
  masterRow: any;
  entry: string;
  valueKey: string;
  highlightIndex = -1;
  columnName: string;
  canAddNewEntry = false;
  blurEntry = false;
  canAddDescription = false;
  displayNone = true;
  isDisabled = false;
  description = '';

  @Input() clearOnSelect;

  @Input()
  set setData(data: any){
    this.allData = data ? [...data] : [];
  }

  @Input()
  set setPlaceHolder(placeHolder: any){
    this.placeHolder = placeHolder;
  }

  @Input()
  set setSearchKey(searchKey: any){
    this.searchKey = searchKey;
  }

  @Input()
  set setMasterRow(masterRow: any){
    this.masterRow = masterRow;
  }

  @Input()
  set setValueKey(valueKey: any){
    this.valueKey = valueKey;
  }

  @Input()
  set setDefaultValue(defaultValue: any){
    setTimeout(() => {
      if (defaultValue){
        this.entry = this.getValue(defaultValue);
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
          this.changeDetectorRef.detectChanges();
        }
      }
    }, 100);
  }

  @Input()
  set setColName(column: any){
    this.columnName = column;
  }

  @Input()
  set setAddNewFlag(newItemFlag: boolean){
    this.canAddNewEntry = newItemFlag;
  }

  @Input()
  set setBlurEntry(newItemFlag: boolean){
    this.blurEntry = newItemFlag;
  }

  @Input()
  set showDescriptionFlag(newItemFlag: boolean){
    this.canAddDescription = newItemFlag;
  }

  @Input()
  set setIsDisabled(disable: boolean){
    this.isDisabled = disable;
  }

  @Input()
  set includeNone(includeNoneOption: boolean){
    if (includeNoneOption == false){
      this.displayNone = includeNoneOption;
    }
  }

  @Output()
  onValueSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onNewItemAddition: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onCharacterTyped: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onBlurEntry: EventEmitter<any> = new EventEmitter<any>();

  constructor(private changeDetectorRef: ChangeDetectorRef){}

  getValue(value){
    const base = this;
    const test = this.valueKey;
    const obj = _.find(this.allData, function(obj){
      return obj[base.valueKey] && ((typeof value) === 'string' ?
        obj[base.valueKey].toLowerCase() == value.toLowerCase() : obj[base.valueKey] === value);
    });
    if (obj){
      return obj[this.searchKey];
    } else {
      return value;
    }
  }

  resetSearchEntries(){
    setTimeout(() => {
      this.searchEntries = [];
      if (this.clearOnSelect) {
        this.entry = '';
      }
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    }, 200);
  }

  filterEntries($event){
    const base = this;
    const searchString = $event.target.value || '';
    if (searchString){
      this.searchEntries = _.filter(this.allData, function(obj){
        return obj[base.searchKey].toLowerCase().indexOf(searchString.toLowerCase()) != -1;
      });
    } else{
      this.searchEntries = [];
    }
    const tempObj = {
      entry: {}
    };
    tempObj.entry[this.searchKey] = searchString;
    tempObj.entry[this.valueKey] = searchString;
    this.onCharacterTyped.emit(tempObj);
  }

  triggerOnSelect($event, entryObj){
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    this.entry = entryObj[this.searchKey];
    this.onValueSelect.emit({
      entry: entryObj,
      row: this.masterRow,
      column: this.columnName
    });
    this.resetSearchEntries();
  }

  triggerOnSelectNone(){
    this.entry = '--None--';
    this.onValueSelect.emit({
      entry: '--None--',
      row: this.masterRow
    });
  }

  highlightNext($event){
    if (this.highlightIndex < this.searchEntries.length - 1){
      this.highlightIndex += 1;
    } else{
      this.highlightIndex = 0;
    }
  }

  highlightPrevious($event){
    if (this.highlightIndex > 0){
      this.highlightIndex -= 1;
    } else{
      this.highlightIndex = this.searchEntries.length - 1;
    }
  }

  selectEntry($event){
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    const entryObj = this.allData[this.highlightIndex];
    this.triggerOnSelect($event, entryObj);
    this.resetSearchEntries();
  }

  highlightAtIndex(index){
    this.highlightIndex = index;
  }

  addNewEntry($event){
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    this.onNewItemAddition.emit({
      newEntry: this.entry,
      description: this.description
    });
    setTimeout( () => {
      this.entry = '';
      this.description = '';
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  setNewEntry($event) {
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    if (!this.entry) {
      this.entry = '';
    }
    this.onBlurEntry.emit({
      newEntry: this.entry,
    });
  }

}
